export default {
  login_register: 'ログイン/登録',
  booking_confirmation_title: '予約確認',
  booking_confirmation_body: 'ご予約いただきありがとうございます。確認の詳細は以下をご覧ください。',
  insurance_requirements_modal_disclaimer: `この予約を行うことにより、私は以下のことを確認します: 過去 5 年間に有罪判決や自動車犯罪はありません。私は、自動車保険会社から提案を拒否されたり、保険契約のキャンセルや更新を拒否されたり、増額保険料の支払いを要求されたり、特別な条件を課されたりしたことはありません。運転免許を剥奪されたことはありません。検察や警察の捜査は保留中です。過去 5 年間に、窃盗、詐欺、不正行為に関する有罪判決はありません。私は、視力や聴力の欠陥（眼鏡や補聴器で矯正されていない）、心臓障害、糖尿病、発作、またはあらゆる種類の身体的または精神的な弱さに苦しんだことはありません。過去5年間、事故を起こしたことはありません。これらの要件を満たさない場合は、{0} をクリックしてください`,
  insurance_requirements_here: 'ここ',
  insurance_requirements: '{0} を読んで理解しました',
  ir: '保険要件',
  location: '位置',
  pickup_location: '受け取り場所',
  dropoff_location: '降車場所',
  vehicle: '車両',
  pickup_and_dropoff: '送迎（現地時間）',
  view_voucher: 'バウチャーを見る',
  identity_verification_body: '車両を引き取る前に本人確認を行う必要があります',
  identity_verification_title: '本人確認',
  search_again: '再検索',
  refrigerated: '冷蔵',
  aircon_lower: 'エアコン',
  aircon: 'エアコン',
  refrigeration: '冷蔵',
  not_available: 'Drive & Go は現在、次の国の身分証明書と運転免許証を持っている人のみが利用できます。',
  check_if_included: '自分の国が含まれているかどうかを確認してください。',
  included_in_booking: 'この予約に含まれるもの',
  cdw_with_excess: 'CDW 過剰',
  theft_protection: '過剰な盗難防止',
  risk_reduction: 'リスクの軽減',
  free_extras: 'この予約では、2 つの無料特典 <br /> をご利用いただけます。',
  continue: '続く',
  luggage_large_short_label: 'L',
  luggage_medium_short_label: 'M',
  luggage_small_short_label: 'S',
  luggage_large_long_label: '大きい',
  luggage_medium_long_label: '中くらい',
  luggage_small_long_label: '小さい',
  fuel_unspecified_label: '不特定',
  transmission_manual_label: 'マニュアル',
  transmission_automatic_label: '自動',
  make_a_booking: '予約する',
  pickup_date: '受け取り日',
  dropoff_date: '返却日',
  driver_age: '30歳から65歳までのドライバー',
  enter_driver_age: 'ドライバーの年齢を入力してください',
  promo_code: 'プロモーションコード',
  search: '検索',
  dropoff_date_cannot_be_before_pickup_date: '返却日を集荷日より前にすることはできません',
  pickup_date_cannot_be_in_the_past: '集荷日を過去にすることはできません',
  pickup_time_cannot_be_in_the_past: 'ピックアップ時刻を過去にすることはできません',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: '同じ日の場合、降車時刻はお迎え時刻より遅くなければなりません',
  vehicle_filters: '車両用フィルター',
  reset: 'リセット',
  transmission: 'トランスミッション',
  all: '全て',
  manual: 'マニュアル',
  auto: '自動',
  passengers: '乗客',
  vehicle_type: '車種',
  filter: 'フィルター',
  vehicle_search: '車両検索',
  edit: '編集',
  no_results: 'フィルタ条件に一致する結果はありません。',
  small_cars: '小型車',
  medium_cars: '中型車',
  large_cars: '大型車',
  estate_cars: 'ステーションカー',
  suvs: 'SUV',
  mpvs: 'MPV',
  vans: 'バン',
  camper_vans: 'キャンピングカー',
  premium: 'プレミアム',
  unspecified: '不特定',
  large: '大きい',
  medium: '中くらい',
  small: '小さい',
  automatic: '自動',
  you_have_been_refunded: '返金されました。',
  please_customer_service: 'ご予約の際はカスタマーサービスまでご連絡ください。',
  contact_customer_service: 'カスタマーサービスに連絡する',
  booking_failed: '今回は予約を処理できませんでした。',
  summary: 'まとめ',
  reforestation_and_protection: 'コスタリカ全土での植林と熱帯雨林の保護を支援する',
  cost_of_rental: 'レンタル料金',
  to_pay_now: '今すぐ支払うには',
  greenheart_donation: 'グリーンハート寄付',
  total_cost: 'レンタル料金の総額',
  tc_agreement: '{0} を読み、理解しました。',
  tc: 'T&Cs',
  receive_offers: '特別オファーをメールで受け取りたいです。',
  donate: 'はい、{amount} を寄付したいと思います',
  pay_now: '今すぐ{amount}を支払います',
  driver_details: 'ドライバーの詳細',
  complete_driver_details: 'ドライバーの詳細を入力してください。',
  are_you_the_driver: 'あなたは運転手ですか？',
  have_an_account: 'すでにアカウントをお持ちですか?',
  login: 'ログイン',
  or: 'または',
  first_name: '運転手の名',
  last_name: 'ドライバーの姓',
  email: '電子メールアドレス',
  phone_number: '携帯電話番号',
  unable_to_save_driver_information: 'ドライバー情報を保存できません。もう一度試してください。',
  pay_online_now: '今すぐ支払う',
  day: '日',
  choose_location: '場所を選択してください',
  location_not_found: '申し訳ございませんが、ご指定の場所が見つかりませんでした。',
  add: '追加',
  remove: '取り除く',
  free_extra: '無料追加',
  free: '無料！',
  fast_track_notice: 'このサービスには文書の発行元の制限が適用されます。からの書類をお持ちの方のみご利用いただけます。',
  complete_booking: '予約を完了する',
  choose_card: 'カードを選択するか、新しいカードを追加してください。',
  add_billing_details: '請求の詳細を追加してください。',
  card_number: 'カード番号',
  card_holder_name: 'カード所有者の名前',
  card_exp: 'MM / YY',
  card_cvc: 'CVC',
  save_card: 'カードを保存しますか？',
  amount_charged: 'カードに請求されます',
  payment_confirmation: '予約を確認して支払いをする',
  payment_methods: '利用可能な支払い方法',
  use_saved_card: '× 保存したカードを使用する',
  use_different_card: '+ 別のカードを使用する',
  book_now: '今すぐ予約する',
  minimum_age: '{age} のみ',
  excess_liability: '過剰な責任',
  security_deposit: '保証金',
  fuel_policy: '燃料政策',
  like_for_like: 'いいねにはいいね',
  full_to_full: 'フルからフルへ',
  miles_per_rental: '{mileage} レンタルごとに無料マイル',
  km_per_rental: '{mileage} レンタルごとに無料キロメートル',
  unlimited_mileage: '走行距離無制限',
  unlimited_mileage_km: '走行距離無制限',
  non_amendable: '修正不可',
  non_refundable: '返金不可',
  free_cancellation_until: 'までキャンセル料無料',
  cancellation_in_line_with: 'に伴うキャンセル',
  tcs: 'T&amp;Cs',
  free_extras_on_collection: 'コレクションの 2 つの無料特典',
  glass_and_tyres_covered: 'ガラスとタイヤが覆われています',
  number_of_passengers: '乗客数',
  number_of_bags: 'バッグの数',
  fuel_type: '燃料の種類',
  co2: 'CO2',
  book_type: '予約 {type}',
  processing: '処理',
  actual_price: '実際の価格',
  tooltip: '{currencyCode} の価格は為替レートに基づく推定値であり、{currency} の価格には拘束力があります。',
  deposit: 'デポジット',
  pay_online: '今すぐ支払う',
  pay_online_without_extras: 'レンタル料金',
  extras_on_arrival: '到着時の追加特典',
  insurance_on_arrival: 'リスク軽減 - 到着時に支払い',
  insurance_online: 'リスク軽減 - 今すぐお支払いください',
  extras_online: '追加料金は今すぐお支払いください',
  green_heart_donation: 'グリーンハート寄付',
  why_use_drive_and_go: 'Drive & Go を使用する理由',
  straight_to_car: '車に直行',
  no_queues: '行列なし',
  self_checkout: 'セルフチェックアウト',
  cant_lose_key: '鍵を失くすことはありません',
  online_id_check: 'オンラインIDチェック',
  phone_as_key: '電話をキーとして',
  premiumplus_benefits_includes: 'Premium Plus+の特典も含まれています',
  book_drive_go: 'ブックドライブ&ゴー',
  distance_allowance: '距離手当',
  duration: '間隔',
  view_more_bookings: 'さらに予約を見る',
  to_pay_on_arrival: '到着時にお支払いいただく場合',
  pay_on_arrival: '到着時にお支払いください',
  unlimited: '無制限',
  return_date: '返却日',
  postcode: '郵便番号',
  country: '国',
  drive_and_go: {
    drive_and_go: 'ドライブ＆ゴー',
    available_countries: 'Drive &amp; Go は現在、次の国の身分証明書と運転免許証を持っている人のみが利用できます。',
    drive_and_go_today: '今すぐドライブ＆ゴーを予約しましょう！',
    drive_and_go_shortened: 'ドライブ＆ゴー',
    why_use_drive_and_go: 'Drive & Go を使用する理由',
    straight_to_car: '車に直行',
    no_queues: '行列なし',
    self_checkout: 'セルフチェックアウト',
    cannot_lose_the_key: '鍵を失くすことはありません',
    online_id_check: 'オンラインIDチェック',
    phone_as_a_key: '電話をキーとして',
    premium_plus_benefits_also_included: 'Premium Plus+の特典も含まれています',
    book_drive_and_go: 'ブックドライブ&ゴー'
  },
  car_and_camp: {
    tent_and_equipment: "テントと装備",
    quick_and_easy: "素早く簡単に設営",
    travel_freedom: "旅の自由",
    affordable_campervan_alternative: "手頃なキャンピングカーの代替",
    lightweight_and_compact: "軽量でコンパクト",
    fully_insured: "完全保険付き",
  },
  my_bookings: "私の予約",
  no_bookings: "予約なし",
  my_profile: '私のプロフィール',
  no_bookings_to_display: '表示する予約はありません。',
  search_great_car_rental_deals: "次回のご旅行にお得なレンタカーを検索してください。",
  odometer_at_collection: '回収時の走行距離計',
  fuel_at_collection: '回収時の燃料',
  start_check_in: 'チェックインを開始する',
  start_collection: '収集を開始する',
  recent_bookings: '最近の予約',
  damage: {
    updated_damage_report_submitted: '最新の被害報告書が提出されました。必要に応じて、カスタマーサービスチームのメンバーがご連絡させていただきます。',
    add_additional_damage: '追加ダメージを追加する',
    you_may_report_additional_damage_up_to: '車両のチェックアウト後 24 時間以内であれば、追加の損傷を報告することができます',
    specify_damage: 'ダメージを指定する',
    please_choose_the_area_and_type_of_damage: '損傷箇所と種類を選択してください',
    type_of_damage: '損傷の種類',
    is_this_more_than_5_cm: 'これは5cm以上あるでしょうか？',
    please_take_or_select_a_photo: '写真を撮るか選択してください',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: '損傷がはっきりとわかるように写真を撮ってください',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' 必要に応じて別の写真を追加できます。アイコンを選択して別の写真を追加します',
    save_image: '画像の保存',
    save_images: '画像の保存',
    damage_saved_successfully: 'ダメージは正常に保存されました',
    add_photo: '写真を追加'
  },
  checkout: {
    start_collection: 'コレクションの開始',
    collect_vehicle: '車両を収集する',
    we_will_let_you_know_the_details: 'レンタカーを見つけるために場所と詳細をお知らせします。',
    inspect: '検査する',
    we_will_ask_for_four_photos_from_each_corner: '車両の各隅から 4 枚の写真と、まだ記載されていない新たな損傷があれば提出していただきます。',
    fuel_and_milage: '燃料と走行距離',
    you_confirm_the_readings_at_the_start_of_your_hire: 'レンタルの開始時に走行距離計と燃料の測定値を確認します。',
    sign: 'サイン',
    sign_the_rental_agreement: 'レンタル契約書に署名します。',
    away_you_go: '去って行ってください',
    you_are_free_to_take_to_the_road: 'あなたは自由に道路に持ち出すことができます！',
    collect_your_vehicle: '車両を回収する',
    get_directions: '道順を調べる',
    hide_directions: 'ルートを非表示にする',
    local_time: '現地時間',
    tel: '電話番号',
    getting_to_the_location: '場所への行き方',
    get_vehicle_details: '車両の詳細を取得する',
    view_map: '地図を見る',
    unlock_vehicle_and_continue: '車両のロックを解除して続行',
    unable_to_connect_to_vehicle: '車両に接続できません',
    we_were_unable_to_connect_to_the_vehicle_please_check: '車両に接続できませんでした。正しい車両の隣にいることを確認して、もう一度お試しください。',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: '車両の予約が見つかりませんでした。後でもう一度試してください。',
    odometer_and_fuel: 'オドメーターと燃料',
    odometer: 'オドメーター',
    please_confirm_the_odometer_and_fuel_readings: '可能であれば、走行距離計と燃料の測定値を確認してください。',
    the_odometer_field_is_required: 'オドメーターフィールドは必須です',
    and_must_be_greater_than_the_checkout_odometer: '& チェックアウトオドメーターより大きくなければなりません',
    confirm: '確認する',
    please_take_a_photo_from_each_corner_of_the_vehicle: '車両の四隅から写真を撮ってください',
    pre_existing_damage: '既存の損傷',
    no_pre_existing_damage: '既存の損傷はありません。',
    new_damage: '新たなダメージ',
    add_additional_damage: '追加ダメージを追加する',
    no_new_damage_to_report: '報告すべき新たな被害はない',
    checkout_complete: 'チェックアウトが完了しました',
    start_rental: 'レンタルを開始する',
    congratulations_name_it_is_time_to_take_to_the_road: 'おめでとうございます {customer_name}、いよいよ出発です!',
    we_are_unable_to_complete_your_vehicle_checkout: '車両のチェックアウトを完了できません。',
    please_do_the_following: '次のことを行ってください',
    remove_all_belonging_and_lock_the_vehicle: 'すべての所持品を取り外し、車両をロックします。',
    lock_vehicle: '車両をロックする',
    once_you_have_contacted_customer_services: 'カスタマーサービスに連絡したら',
    vehicle_location: '車両の位置',
    collect_your: 'あなたのものを集めてください',
    from: 'から',
    key_in_glove_box: 'あなたのキーはグローブボックスの中にあります',

    keyholder: {
      not_detected: 'キーホルダーでキーが検出されない',
      not_detected_please_try_again: 'キーをキーホルダーに置いてから、もう一度お試しください。',

      not_installed: 'キーホルダーは取り付けられていません',
      not_installed_please_contact_customer_service: 'キーホルダーは取り付けられていませんので、カスタマーサービスにお問い合わせください。',
    },
    keyring: {
      look_up_failed: 'キーリングの検索に失敗しました',
      look_up_failed_please_contact_customer_service: 'キーリングの検索に失敗しました。カスタマー サービスにお問い合わせください。',
    },
    key: {
      invalid: 'キーが無効です',
      invalid_please_contact_customer_service: 'キーが無効です。カスタマー サービスにお問い合わせください。',

      expired: 'キーの有効期限が切れています',
      expired__please_contact_customer_service: 'キーの有効期限が切れています。カスタマー サービスにお問い合わせください。',
    }
  },
  checkin: {
    start_check_in: 'チェックインを開始する',
    vehicle_location: '車両の位置',
    tell_us_where_you_have_parked: '車を駐車した場所を教えてください。',
    fuel_and_milage: '燃料と走行距離',
    you_confirm_the_readings_at_the_end_of_your_hire: 'レンタルの最後に、走行距離計と燃料の測定値を確認します。',
    inspect: '検査する',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'レンタル中に発生した新たな損傷とともに、車両の各隅からの写真 4 枚の提出を求められます。',
    lock: 'ロック',
    check_you_have_left_no_belonging_then_lock_the_vehicle: '忘れ物がないことを確認してから車を施錠してください。',
    please_tell_us_where_you_have_parked_the_vehicle: '車を駐車した場所を教えてください',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: '車両がロックされると、再度ロックを解除することはできません。',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}、忘れ物がないことを確認し、車両を施錠し、必要に応じて物理キーをキーホルダーに返却してください。',
    lock_vehicle: '車両をロックする',
    complete_check_in: 'チェックインを完了する',
    inspection: '検査',
    complete_vehicle_check_in: '車両のチェックインを完了する',
    we_are_unable_to_complete_your_vehicle_check_in: '車両のチェックインを完了できません。',
    please_contact_customer_services: 'カスタマーサービスにお問い合わせください',
    once_you_have_contacted_customer_services: 'カスタマーサービスに連絡したら',
    please_amend_odometer_to_be_greater_than: 'オドメーターを {odometer_value} より大きくなるように修正してください',
  },
  rental_agreement: {
    rental_agreement: 'レンタル契約書',
    agreement_between: '間の合意',
    and: 'そして',
    sign_rental_agreement: 'レンタル契約書に署名する',
    i_have_read_and_understood_the_terms_and_conditions: '私は利用規約を読んで理解し、車両の状態に同意します。',
  },
  additional_options: '追加オプション',
  booking_details: '予約の詳細',
  price_for_x_days: '{qty_of_days} 日の料金 | {qty_of_days} 日分の料金',
  cancelled: 'キャンセル',
  upcoming: '今後の予定',
  active: 'アクティブ',
  full_insurance_no_deposit: '保険完備＆頭金不要',
  excess: '{amount}過剰',
  deposit: '{amount} の預金',
  included_daily_distance: '{distance} {unit}/日',
  miles: 'マイル',
  kilometers: 'キロメートル',
  collection_details_title: 'コレクションの詳細',
  collection_details_not_found: 'この場所にはコレクションの詳細が定義されていません',
  free_cancellation: '無料キャンセル',
  no_deposit: 'デポジットなし',
  benefit_from: '恩恵を受ける',
  for_only_per_day: '1 日あたり {price} のみ',
  upgrade_mee: 'アップグレードミー'
}
